import { SVGProps, Ref, forwardRef } from 'react';

export const MaxSquareSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.139 5.63v.002a2.4 2.4 0 0 1 2.259 2.484 2.395 2.395 0 0 1-2.507 2.232 2.33 2.33 0 0 1-1.14-.405c-.203.204-.53.467-.66.436-.271-.073-.588-1.448-.41-2.578C5.9 6.436 6.88 5.565 8.14 5.63"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.083 1A2.917 2.917 0 0 1 15 3.917v8.166A2.917 2.917 0 0 1 12.083 15H3.917A2.917 2.917 0 0 1 1 12.083V3.917A2.917 2.917 0 0 1 3.917 1zM8.076 3.333c-2.585 0-4.767 2-4.767 4.656 0 1.112.206 1.88.387 2.57.153.56.287 1.072.287 1.678.066.808 1.554.336 2.025-.268.744.537 1.172.67 2.093.67a4.61 4.61 0 0 0 4.59-4.626c0-2.582-2.027-4.68-4.615-4.68"
                fill="currentColor"
            />
        </g>
    </svg>
));
MaxSquareSolidSize16Glyph.displayName = 'MaxSquareSolidSize16Glyph';
